import React, { forwardRef } from 'react';
import classNames from 'classnames';

import './_button-filter.scss'
import './_button-filter.dark-mode.scss'
import PropTypes from 'prop-types';
import { useDropdown } from '../../Dropdown';
import { Flex } from '../../Layout';

const ButtonFilter = forwardRef(
  (props, ref) => {
    const { close } = useDropdown()
    const { activeText, name, onClear, onClick } = props;

    const onClickClear = (e) => {
      e.stopPropagation();
      if (onClear) {
        onClear(e)
        close()
      }
    }

    return (
      <button
        title={`${name}${activeText ? `: ${activeText}` : ''}`}
        onClick={onClick}
        ref={ref}
        className={classNames('button-filter',
          {
            'button-filter--default': !onClear,
            active: activeText,
          })}
      >
        {activeText
          ? (
            <>
              {onClear
                ? (
                  <Flex
                    align="center"
                    justify="center"
                    shrink={0}
                    className="button-filter__icon button-filter__icon-close"
                  >
                    <svg
                      onClick={onClickClear}
                      width="18"
                      height="18"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="Reset filter" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <path
                          d="M8,2 C11.3137085,2 14,4.6862915 14,8 C14,11.3137085 11.3137085,14 8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 Z M6.40900974,5.34834957 C6.2137476,5.15308742 5.89716511,5.15308742 5.70190296,5.34834957 L5.34834957,5.70190296 C5.15308742,5.89716511 5.15308742,6.2137476 5.34834957,6.40900974 L6.93933983,8 L5.34834957,9.59099026 C5.15308742,9.7862524 5.15308742,10.1028349 5.34834957,10.298097 L5.70190296,10.6516504 C5.89716511,10.8469126 6.2137476,10.8469126 6.40900974,10.6516504 L8,9.06066017 L9.59099026,10.6516504 C9.7862524,10.8469126 10.1028349,10.8469126 10.298097,10.6516504 L10.6516504,10.298097 C10.8469126,10.1028349 10.8469126,9.7862524 10.6516504,9.59099026 L9.06066017,8 L10.6516504,6.40900974 C10.8469126,6.2137476 10.8469126,5.89716511 10.6516504,5.70190296 L10.298097,5.34834957 C10.1028349,5.15308742 9.7862524,5.15308742 9.59099026,5.34834957 L8,6.93933983 Z"
                          id="Combined-Shape"
                          fill="currentColor"
                        />
                      </g>
                    </svg>
                  </Flex>
                ) : null}
            </>
          )
          : (
            <Flex
              align="center"
              justify="center"
              shrink={0}
              className="button-filter__icon"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 16 16"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="Add filter" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <path
                    d="M8,2 C11.3137085,2 14,4.6862915 14,8 C14,11.3137085 11.3137085,14 8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 Z M8.25,4.5 L7.75,4.5 C7.47385763,4.5 7.25,4.72385763 7.25,5 L7.25,7.25 L5,7.25 C4.72385763,7.25 4.5,7.47385763 4.5,7.75 L4.5,8.25 C4.5,8.52614237 4.72385763,8.75 5,8.75 L7.25,8.75 L7.25,11 C7.25,11.2761424 7.47385763,11.5 7.75,11.5 L8.25,11.5 C8.52614237,11.5 8.75,11.2761424 8.75,11 L8.75,8.75 L11,8.75 C11.2761424,8.75 11.5,8.52614237 11.5,8.25 L11.5,7.75 C11.5,7.47385763 11.2761424,7.25 11,7.25 L8.75,7.25 L8.75,5 C8.75,4.72385763 8.52614237,4.5 8.25,4.5 Z"
                    id="Combined-Shape"
                    fill="currentColor"
                  />
                </g>
              </svg>
            </Flex>
          )}
        <span className="button-filter__name">
          {name}
          {activeText ? ':' : null}
        </span>
        {activeText ? <span className="button-filter__value">{activeText}</span> : null}
      </button>
    )
  },
)

ButtonFilter.propTypes = {
  activeText: PropTypes.string,
  name: PropTypes.string,
  onClear: PropTypes.func,
  onClick: PropTypes.func,
}

ButtonFilter.defaultProps = {
  activeText: null,
  name: 'Source',
}

export default ButtonFilter
